import React from 'react';
import { Link } from 'react-router-dom';

const courses = [
  {
    category: 'Web Technologies',
    icon: '🌐',
    items: ['HTML, CSS & JavaScript', 'React JS', 'Angular', 'Node.js', 'PHP & MySQL', 'WordPress Development'],
  },
  {
    category: 'Software Development',
    icon: '💻',
    items: ['Java Programming', '.NET / C#', 'Python Programming', 'C & C++', 'Data Structures & Algorithms', 'Object Oriented Programming'],
  },
  {
    category: 'Database Technologies',
    icon: '🗄️',
    items: ['SQL Server', 'Oracle', 'MySQL', 'MongoDB', 'Database Design & Modelling', 'Data Warehousing'],
  },
  {
    category: 'Mobile App Development',
    icon: '📱',
    items: ['Android Development', 'iOS Development', 'React Native', 'Flutter', 'Hybrid App Development'],
  },
  {
    category: 'Digital Marketing',
    icon: '📈',
    items: ['Search Engine Optimization (SEO)', 'Google Ads / SEM', 'Social Media Marketing', 'Content Marketing', 'Email Marketing', 'Online Reputation Management'],
  },
  {
    category: 'IT Infrastructure & Support',
    icon: '🛠️',
    items: ['Networking Fundamentals', 'Cloud Computing (AWS, Azure)', 'Cybersecurity Basics', 'Linux Administration', 'IT Help Desk Support'],
  },
  {
    category: 'Graphic Design & Multimedia',
    icon: '🎨',
    items: ['Adobe Photoshop', 'Adobe Illustrator', 'CorelDRAW', 'Video Editing', 'UI/UX Design'],
  },
  {
    category: 'Soft Skills & Management',
    icon: '🤝',
    items: ['Project Management', 'Business Communication', 'Leadership & Team Management', 'Time Management', 'Presentation Skills'],
  },
];

const trainingModes = [
  { icon: '🏫', title: 'Classroom Training', desc: 'Instructor-led training at our state-of-the-art facilities in USA and India.' },
  { icon: '💻', title: 'Online Training', desc: 'Live virtual sessions with real-time interaction from anywhere in the world.' },
  { icon: '🏢', title: 'Corporate Training', desc: 'Customized on-site training programs tailored to your organization\'s needs.' },
  { icon: '🎓', title: 'Self-Paced Learning', desc: 'Flexible recorded sessions you can access anytime at your own pace.' },
];

const whyChoose = [
  { icon: '👨‍🏫', title: 'Expert Trainers', desc: 'Industry professionals with 10+ years of hands-on experience.' },
  { icon: '📋', title: 'Certified Programs', desc: 'Globally recognized certifications upon course completion.' },
  { icon: '🔧', title: 'Hands-On Projects', desc: 'Real-world projects and case studies for practical learning.' },
  { icon: '💼', title: 'Placement Assistance', desc: 'Career guidance and job placement support after training.' },
  { icon: '🔄', title: 'Flexible Schedules', desc: 'Weekday, weekend, and fast-track batches available.' },
  { icon: '🌍', title: 'Global Standards', desc: 'Training aligned with international industry standards.' },
];

const Training = () => (
  <>
    {/* Hero */}
    <section className="py-5 text-white text-center" style={{ background: 'linear-gradient(135deg, #002868, #1a56db)' }}>
      <div className="container py-4">
        <span className="badge bg-warning text-dark mb-3 px-3 py-2">Professional Development</span>
        <h1 className="fw-bold">Training & Development</h1>
        <p className="lead" style={{ color: '#cbd5e1' }}>
          Empowering individuals and organizations with cutting-edge IT and professional skills training.
        </p>
        <div className="d-flex justify-content-center gap-3 mt-4">
          <Link to="/contact" className="btn btn-warning btn-lg fw-bold">Enroll Now →</Link>
          <Link to="/contact" className="btn btn-outline-light btn-lg">Get a Brochure</Link>
        </div>
      </div>
    </section>

    {/* Intro */}
    <section className="py-5 bg-white">
      <div className="container py-4">
        <div className="row align-items-center g-5">
          <div className="col-12 col-lg-6">
            <div className="rounded-4 d-flex align-items-center justify-content-center"
              style={{ height: 320, background: 'linear-gradient(135deg, #dbeafe, #e0e7ff)', fontSize: 90 }}>🎓</div>
          </div>
          <div className="col-12 col-lg-6">
            <span className="badge bg-primary bg-opacity-10 text-primary px-3 py-2 mb-3">ABOUT OUR TRAINING</span>
            <h2 className="fw-bold mb-3">Build Skills That Drive Success</h2>
            <p className="text-muted">
              EGB Systems and Solutions, Inc. offers comprehensive training and development programs designed to equip
              professionals and students with the latest technology skills. Our training division has been helping
              individuals and corporations bridge the skill gap since 1999.
            </p>
            <p className="text-muted">
              Whether you are a fresher looking to start your IT career or a professional seeking to upgrade your skills,
              our expert-led programs are tailored to meet your goals.
            </p>
            <div className="row g-3 mt-2">
              {[{ value: '500+', label: 'Students Trained' }, { value: '50+', label: 'Courses Offered' }, { value: '25+', label: 'Years Experience' }, { value: '95%', label: 'Placement Rate' }].map(stat => (
                <div key={stat.label} className="col-6">
                  <div className="p-3 rounded-3 text-center bg-light">
                    <div className="fw-bold fs-4 text-primary">{stat.value}</div>
                    <div className="small text-muted">{stat.label}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* Training Modes */}
    <section className="py-5 bg-light">
      <div className="container py-4">
        <div className="text-center mb-5">
          <span className="badge bg-primary bg-opacity-10 text-primary px-3 py-2 mb-2">HOW WE TRAIN</span>
          <h2 className="fw-bold">Training Modes</h2>
          <p className="text-muted">Flexible learning options to suit your schedule and preference.</p>
        </div>
        <div className="row g-4">
          {trainingModes.map((m, i) => (
            <div key={i} className="col-12 col-sm-6 col-lg-3">
              <div className="card h-100 border-0 shadow-sm text-center p-4">
                <div style={{ fontSize: 44 }} className="mb-3">{m.icon}</div>
                <h5 className="fw-bold">{m.title}</h5>
                <p className="text-muted small">{m.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* Courses */}
    <section className="py-5 bg-white">
      <div className="container py-4">
        <div className="text-center mb-5">
          <span className="badge bg-primary bg-opacity-10 text-primary px-3 py-2 mb-2">WHAT WE OFFER</span>
          <h2 className="fw-bold">Our Training Programs</h2>
          <p className="text-muted">Industry-relevant courses across technology, design, and business domains.</p>
        </div>
        <div className="row g-4">
          {courses.map((c, i) => (
            <div key={i} className="col-12 col-sm-6 col-lg-4">
              <div className="card h-100 border-0 shadow-sm p-3">
                <div className="card-body">
                  <div className="d-flex align-items-center gap-2 mb-3">
                    <span style={{ fontSize: 28 }}>{c.icon}</span>
                    <h6 className="fw-bold mb-0">{c.category}</h6>
                  </div>
                  <ul className="list-unstyled mb-0">
                    {c.items.map(item => (
                      <li key={item} className="small text-muted mb-1">✔ {item}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* Why Choose Us */}
    <section className="py-5 bg-light">
      <div className="container py-4">
        <div className="text-center mb-5">
          <span className="badge bg-primary bg-opacity-10 text-primary px-3 py-2 mb-2">WHY EGB TRAINING</span>
          <h2 className="fw-bold">Why Choose Us?</h2>
          <p className="text-muted">We go beyond teaching — we build careers.</p>
        </div>
        <div className="row g-4">
          {whyChoose.map((w, i) => (
            <div key={i} className="col-12 col-sm-6 col-lg-4">
              <div className="card h-100 border-0 shadow-sm p-4 text-center">
                <div style={{ fontSize: 40 }} className="mb-3">{w.icon}</div>
                <h6 className="fw-bold">{w.title}</h6>
                <p className="text-muted small">{w.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* CTA */}
    <section className="py-5 text-white text-center" style={{ background: 'linear-gradient(135deg, #1a56db, #0ea5e9)' }}>
      <div className="container py-4">
        <h2 className="fw-bold mb-3">Ready to Advance Your Career?</h2>
        <p className="lead mb-4">Join thousands of professionals trained by EGB Systems.</p>
        <Link to="/contact" className="btn btn-warning btn-lg fw-bold px-5">Contact Us →</Link>
      </div>
    </section>
  </>
);

export default Training;
